import React from "react";
import { FieldError } from "react-hook-form";

interface InputFieldProps {
  type: "text" | "password" | "email" | "number";
  placeholder: string;
  disabled?: boolean;
  register?: any;
  error: FieldError | undefined;
  classes?: string,
  value?: string,
  maxLength?: number,
  rounded?:string,
  padding?:string;
  bg?:string
  border?:string
  updatedStyle?:string
}

const FormHookInput: React.FC<InputFieldProps> = ({
  type,
  placeholder,
  register,
  disabled,
  classes,
  error,
  value,
  maxLength,
  rounded,
  padding,
  bg,
  border,
  updatedStyle,
  

}) => {


  // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  // return 
  // };
  return (
    <>
      <input
        value={value}
        maxLength={maxLength}
        disabled={disabled}
        // onChange={handleInputChange}
        className={`${updatedStyle? `${updatedStyle} ${disabled ? 'bg-[#fcfcfd':'bg-p-gray'}`:`w-full ${bg && bg} ${padding ?padding:'px-4 py-2'} ${border && border}  ${rounded ? rounded:'rounded-full'}  w-full px-4 py-3 bg-p-gray     focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600 ${classes}` }`}
        type={type}
        placeholder={placeholder}
        {...register}
      />
      {error && (
        <p className="text-red-500 text-xs mt-1 py-">{error.message}</p>
      )}
    </>
  );
};

export default FormHookInput;
